import React from "react";
import { transformComma } from "../../../utils/validator/comma";

const PensionSupportTargets = ({ data }) => {
  if (!data) {
    return <p>데이터가 없습니다.</p>;
  }

  const supportList = data?.list || []; // 연금보험료 지원대상자 리스트

  return (
    <>
      {/* 연금보험료 지원대상자 테이블 */}
      <h4 className="si4n-subtitle">연금보험료 지원대상자</h4>
      <table className="si4n-table">
        <thead>
          <tr>
            <th>순번</th>
            <th>성명</th>
            <th>주민등록번호</th>
            <th>지원대상연월</th>
            <th>연금보험료</th>
            <th>보험료 지원율</th>
            <th>전월분 보험료 지원금</th>
            <th>본인부담금</th>
            <th>본인기여금</th>
          </tr>
        </thead>
        <tbody>
          {supportList.length > 0 ? (
            supportList.map((person, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{person.gookName}</td>
                <td>{person.gookRrno?.replace(/.{6}$/, "******")}</td>
                <td>{person.gookDcsnYm}</td>
                <td>{transformComma(person.gookInsAmt)} 원</td>
                <td>{person.gookPnsIamNtsrSbsdRte}%</td>
                <td>{transformComma(person.gookAssAmt)} 원</td>
                <td>{transformComma(person.gookprivInsEmplPay)} 원</td>
                <td>{transformComma(person.gookprivInsPrsnPay)} 원</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9">지원대상자가 없습니다.</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default PensionSupportTargets;
